import ClassFeaturePane from './ClassFeaturePane';

export default ClassFeaturePane;
export { ClassFeaturePane };
